import { Component, OnInit } from '@angular/core';
import { Ng2IzitoastService } from 'ng2-izitoast';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { V4Service } from 'src/app/services/v4.service';
import { GruposService } from 'src/app/services/grupos.service';

@Component({
  selector: 'app-v2-familias',
  templateUrl: './v2-familias.component.html',
  styleUrls: ['./v2-familias.component.scss']
})
export class V2FamiliasComponent implements OnInit {
  familias: any[] = [];
  grupos: any[] = [];
  filtro = '';
  formulario = { nombre: '', descripcion: '', activo: 1 };
  formularioEdit = { id: 0, nombre: '', descripcion: '', activo: 1 };
  imagenFamiliaNueva: File | null = null;
  imagenFamiliaEditar: File | null = null;

  familiaSeleccionada: any = null;
  gruposSeleccionados: number[] = [];
  loading = false;

  constructor(
    private v4: V4Service,
    private gruposService: GruposService,
    private iziToast: Ng2IzitoastService,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    this.getFamilias();
    this.getGrupos();
  }

  getFamilias(): void {
    this.loading = true;
    this.v4.getFamilias().subscribe(
      (data: any) => {
        this.loading = false;
        if (data.success) {
          this.familias = data.content;
        }
      },
      (error) => {
        this.loading = false;
        console.error(error);
      }
    );
  }

  getGrupos(): void {
    this.gruposService.getGruposNombre().subscribe(
      (data: any) => {
        if (data.success) {
          this.grupos = data.content;
        }
      },
      (error) => console.error(error)
    );
  }

  get familiasFiltradas() {
    const term = this.filtro.toLowerCase();
    return this.familias.filter((f) => {
      const nombre = f.nombre ? f.nombre.toLowerCase() : '';
      const descripcion = f.descripcion ? f.descripcion.toLowerCase() : '';
      return nombre.includes(term) || descripcion.includes(term);
    });
  }

  agregarFamilia(): void {
    this.v4.crearFamilia({ ...this.formulario, imagen: this.imagenFamiliaNueva }).subscribe(
      (data: any) => {
        if (data.success) {
          this.toast('Familia creada');
          this.formulario = { nombre: '', descripcion: '', activo: 1 };
          this.imagenFamiliaNueva = null;
          this.getFamilias();
        }
      },
      (error) => console.error(error)
    );
  }

  abrirEditar(modal: any, familia: any): void {
    this.formularioEdit = {
      id: familia.id,
      nombre: familia.nombre || '',
      descripcion: familia.descripcion || '',
      activo: familia.activo === 0 ? 0 : 1
    };
    this.imagenFamiliaEditar = null;
    this.modalService.open(modal, { ariaLabelledBy: 'modal-editar-familia' });
  }

  actualizarFamilia(): void {
    this.v4
      .actualizarFamilia(this.formularioEdit.id, {
        nombre: this.formularioEdit.nombre,
        descripcion: this.formularioEdit.descripcion,
        activo: this.formularioEdit.activo,
        imagen: this.imagenFamiliaEditar
      })
      .subscribe(
      (data: any) => {
        if (data.success) {
          this.toast('Familia actualizada');
          this.modalService.dismissAll();
          this.imagenFamiliaEditar = null;
          this.getFamilias();
        }
      },
      (error) => console.error(error)
    );
  }

  eliminarFamilia(id: number): void {
    if (!confirm('¿Eliminar familia?')) {
      return;
    }
    this.v4.eliminarFamilia(id).subscribe(
      (data: any) => {
        if (data.success) {
          this.toast('Familia eliminada');
          this.getFamilias();
        }
      },
      (error) => console.error(error)
    );
  }

  abrirGrupos(modal: any, familia: any): void {
    this.familiaSeleccionada = familia;
    this.gruposSeleccionados = [];
    this.v4.getFamiliaGrupos(familia.id).subscribe(
      (data: any) => {
        if (data.success) {
          this.gruposSeleccionados = (data.content || [])
            .map((item: any) => Number(item.grupo))
            .filter((id: number) => !Number.isNaN(id));
        }
      },
      (error) => console.error(error)
    );
    this.modalService.open(modal, { size: 'lg', ariaLabelledBy: 'modal-grupos-familia' });
  }

  grupoSeleccionado(grupoId: number): boolean {
    return this.gruposSeleccionados.indexOf(Number(grupoId)) !== -1;
  }

  seleccionarGrupo(grupoId: number, event: any): void {
    const id = Number(grupoId);
    if (event.target.checked) {
      if (!this.grupoSeleccionado(id)) {
        this.gruposSeleccionados.push(id);
      }
      return;
    }
    this.gruposSeleccionados = this.gruposSeleccionados.filter((item) => item !== id);
  }

  guardarGrupos(): void {
    if (!this.familiaSeleccionada) {
      return;
    }
    this.v4.configurarFamiliaGrupos({
      familia: this.familiaSeleccionada.id,
      grupos: this.gruposSeleccionados
    }).subscribe(
      (data: any) => {
        if (data.success) {
          this.toast('Grupos actualizados');
          this.modalService.dismissAll();
        }
      },
      (error) => console.error(error)
    );
  }

  onFileChangeNuevo(event: any): void {
    const file = event.target.files[0];
    this.imagenFamiliaNueva = file || null;
  }

  onFileChangeEditar(event: any): void {
    const file = event.target.files[0];
    this.imagenFamiliaEditar = file || null;
  }

  private toast(title: string): void {
    this.iziToast.show({
      title,
      titleColor: '#f8f8ff',
      color: '#4CAF50',
      position: 'topRight',
      closeOnEscape: true
    });
  }
}
